import { render } from "./About.vue?vue&type=template&id=0c9a6239&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=0c9a6239&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c9a6239"

export default script